import React from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";

import { useFormContext, Controller } from "react-hook-form";
import { inputLabelStyles } from "../styles";

const ProjectContentSexual = () => {
  const theme = useTheme();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  
  return(
    <React.Fragment>
      <Grid xs={4} spacing={2}>
        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Sexual Content</InputLabel>
          <Controller
            control={control}
            name="sexualContent"
            render={({ field }) => (
              <Select
                id="sexualContent"
                fullWidth
                label="Sexual Content"
                defaultValue="None"
                sx={{ backgroundColor: theme.palette.background.paper}}
                {...register("sexualContent", { required: true })}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Mild">Mild</MenuItem>
                <MenuItem value="Moderate">Moderate</MenuItem>
                <MenuItem value="Explicit">Explicit</MenuItem>
              </Select>
            )}
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Nudity</InputLabel>
          <Controller
            control={control}
            name="nudity"
            render={({ field }) => (
              <Select
                id="nudity"
                fullWidth
                label="Nudity"
                defaultValue="None"
                sx={{ backgroundColor: theme.palette.background.paper}}
                {...register("nudity", { required: true })}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Mild">Mild</MenuItem>
                <MenuItem value="Moderate">Moderate</MenuItem>
                <MenuItem value="Explicit">Explicit</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        </Grid>
    </React.Fragment>
  );
}

export default ProjectContentSexual;